export class FaturaCompetenciaModel {
    constructor(
        public competenciaAnoMes: number = 0,
        public dataVencimento: string = '',
    ) { }
}